/**
 * Module-level session state shared by the api client and the logout flow.
 *
 * These are set once during bootstrap (see `setRealAuthHeaders` / `setRealUrlPrefix`)
 * and read synchronously afterwards, which is why they live outside React state.
 */

export type AuthHeaders = Awaited<ReturnType<typeof window.getAuthHeaders>>;

let realAuthHeaders: AuthHeaders | undefined;
let realUrlPrefix = '';

export function getAuthorizationHeader(): string {
    return `Basic ${btoa(`${localStorage.getItem('csrfToken')}:x-session-token`)}`;
}

export function setRealAuthHeaders(authHeaders: AuthHeaders): void {
    realAuthHeaders = authHeaders;
}

export function setRealUrlPrefix(urlPrefix: string): void {
    realUrlPrefix = urlPrefix;
}

export function getRealAuthHeaders(): AuthHeaders {
    if (typeof realAuthHeaders === 'undefined') {
        throw new Error('realAuthHeaders unexpectedly undefined');
    }
    return realAuthHeaders;
}

/**
 * Non-throwing read, for building request headers.
 *
 * Only the mock-web bootstrap path calls `setRealAuthHeaders`; on plain web these are
 * never set and the client is expected to build without them. Use this rather than
 * `getRealAuthHeaders` anywhere the absence is legitimate.
 */
export function peekRealAuthHeaders(): AuthHeaders | undefined {
    return realAuthHeaders;
}

export function getRealUrlPrefix(): string {
    if (typeof realUrlPrefix === 'undefined') {
        throw new Error('realUrlPrefix unexpectedly undefined');
    }
    return realUrlPrefix;
}
